import React, { useEffect, useRef, useState} from 'react'
import styles from './FieldSystemPage.module.css'
import {
    AppBar,
    Button
} from '@material-ui/core'
import Typography from '@mui/material/Typography'
import cn from 'classnames'
import axios from "axios";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {getConfig} from "../../AppConfig";
import MaskedInput from "../../components/common/inputs/MaskedInput";
import HookForm from "../../components/common/HookForm";
import {useForm} from "react-hook-form";
import {Alert, Grid} from "@mui/material";
import SelectInput from "../../components/common/inputs/SelectInput";

interface Params {
    userGuid: string
}

interface FormData {
    phone: string,
    companyselection: string
}

export const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/

const PhonePage = () => {
    const formMethods = useForm<FormData>()
    const { fieldappversion } = getConfig()
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [showCompanyList, setShowCompanyList] = React.useState(false)
    const [companyList, setCompanyList] = React.useState([])

    const onSubmit = async (data: FormData) => {
        setLoadingBackdrop(true)
        const body = {
            phone: data.phone
        }

        if (data.companyselection) {
            body['entityid'] = data.companyselection
        }

        axios.post(`fieldsystemphone`, body).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            if (parsedResponse.status === 'CompanyRequired') {
                setCompanyList(parsedResponse?.companylist.map(item => { return {label: item.companycode, value: item.entityid}}))
                setShowCompanyList(true)
            }
            else {
                setShowCompanyList(false)
            }
            setLoadingBackdrop(false)
            setSnackbarOpen( { open: true, message: parsedResponse.message})
        })
    }

    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    return (
        <div className={styles.root}>
            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <AppBar position="absolute" className={cn(styles.appBar, styles.shift)}>
                    <Typography style={{display: 'inline-block'}} variant="h6" color="primary" component="div" align="center">
                        {'Alvah Group Field System'}
                        <Typography textAlign="right" fontSize={'11px'} style={{display: 'inline-block', paddingLeft: '2px'}} variant="caption" color="textDisabled" component="div" >
                            {fieldappversion}
                        </Typography>
                    </Typography>
                </AppBar>
                <LoadingBackdrop open={loadingBackdrop} />
                <>
                    <HookForm
                        methods={formMethods}
                        onSubmit={onSubmit}
                        className={styles.form}>
                        <MaskedInput
                            name="phone"
                            label="Phone"
                            defaultValue=""
                            thousandSeparator={false}
                            thousandsGroupStyle={""}
                            prefix={""}
                            format={"(###) ###-####"}
                            mask={"_"}
                            required={true}
                            rules={{
                                pattern: {
                                    value: phoneRegex,
                                    message: 'Please enter a valid phone number.'
                                }
                            }}
                        />
                        {showCompanyList &&
                            <SelectInput
                                name={'companyselection'}
                                label={'Company'}
                                options={companyList}
                                required={showCompanyList}
                            />
                        }
                        <Button type="submit" variant="contained" style={{width: '100%'}}>
                            Send Link
                        </Button>
                    </HookForm>
                </>
            </>
        </div>
    )
}

export default PhonePage